// extracted by mini-css-extract-plugin
module.exports = {"root":"UVControlButtonsSelector_root__19oI3"};